import { render, staticRenderFns } from "./PoistenieControl.vue?vue&type=template&id=4393f988&"
import script from "./PoistenieControl.vue?vue&type=script&lang=js&"
export * from "./PoistenieControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VItem,VItemGroup,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4393f988')) {
      api.createRecord('4393f988', component.options)
    } else {
      api.reload('4393f988', component.options)
    }
    module.hot.accept("./PoistenieControl.vue?vue&type=template&id=4393f988&", function () {
      api.rerender('4393f988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/poistenie/PoistenieControl.vue"
export default component.exports